import { render, staticRenderFns } from "./_PermissaoFormAdicionar.vue?vue&type=template&id=1512025d&scoped=true"
import script from "./_PermissaoFormAdicionar.vue?vue&type=script&lang=ts"
export * from "./_PermissaoFormAdicionar.vue?vue&type=script&lang=ts"
import style0 from "./_PermissaoFormAdicionar.vue?vue&type=style&index=0&id=1512025d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512025d",
  null
  
)

export default component.exports